import { Stack } from "@mui/material";
import { useContext } from "react";
import * as yup from "yup";
import { ConstantContext } from "components/context/ConstantProvider";
import { Form } from "components/shared/Form";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import RHFCheckbox from "components/ui/atoms/formFields/RHFCheckbox";

const validationSchema = yup.object({
  action_type: yup.string(),
  past_events: yup.boolean(),
});

const getInitialValues = (object) => {
  return {
    action_type: object?.action_type || "",
    past_events: object?.past_events === undefined ? true : object?.past_events,
  };
};

const TimeLineForm = (props) => {
  const { actionTypes } = useContext(ConstantContext);

  return (
    <Form
      validationSchema={validationSchema}
      prepareInitialValues={getInitialValues}
      neverLock
      {...props}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <RHFCheckbox name="past_events" label="Past events" />
        <ListSelectField
          options={actionTypes}
          name="action_type"
          label="Action type"
          sx={{ width: 100 }}
          size="small"
        />
      </Stack>
    </Form>
  );
};

export default TimeLineForm;
